module.exports = __webpack_public_path__ + "img/IsoLogo_Area.6263d302.png";